import Spinner from '../Spinner';
import React from 'react';

interface DropdownProps {
  options: string[];
  right?: boolean;
  fullWidth?: boolean;
  scrollableList?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>, option: string) => void;
  zIndexClassName?: string;
  isLoading?: boolean;
  noOptionsText?: string;
  testID?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  right = false,
  fullWidth = false,
  scrollableList = false,
  onClick,
  zIndexClassName = 'z-50',
  isLoading = false,
  noOptionsText,
  testID,
}) => {
  const alignment = right ? 'right-0' : 'left-0';
  return (
    <div
      className={`${fullWidth ? 'w-full' : 'w-max'} ${
        scrollableList ? 'max-h-48 overflow-y-scroll' : ''
      } ${zIndexClassName} flex flex-col ${alignment} items-start absolute top-full py-2.5 bg-white rounded-b-large rounded-l-large gap-px shadow-container`}
      data-testid={testID}
    >
      {!isLoading &&
        (options.length >= 1
          ? options.map((option, index) => (
              <div
                key={index}
                className="flex flex-row w-full items-start px-5 py-[7px] hover:bg-light-blue gap-2.5 cursor-pointer"
                onClick={(event) => onClick(event, option)}
                data-testid={
                  'option-' + option?.replaceAll(' ', '-').toLowerCase()
                }
              >
                <p className="text-base font-semibold text-dark-gray">
                  {option}
                </p>
              </div>
            ))
          : noOptionsText && (
              <div
                className="my-5 w-full text-med-gray-3 flex items-center justify-center"
                data-testid={'empty-list'}
              >
                {noOptionsText}
              </div>
            ))}

      {isLoading && (
        <div className="my-5 w-full flex items-center justify-center">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Dropdown;
